module.exports = __webpack_public_path__ + "static/media/trash-can-solid.d44e1d63.png";